import { ac, roles } from "@shared/permissions";
import { adminClient, inferAdditionalFields } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { getApiBaseUrl } from "./api-config";

const baseURL = getApiBaseUrl();

export const authClient = createAuthClient({
  ...(baseURL ? { baseURL } : {}),
  // Mirror the server-side user additionalFields (see worker/index.ts's
  // createAuth) so session.user.accountId / accountRole are typed on the client.
  plugins: [
    inferAdditionalFields({
      user: {
        // input: false mirrors the server (these are server-assigned, never
        // supplied at sign-up) so they don't become required signUp params.
        accountId: { type: "string", input: false },
        accountRole: { type: "string", input: false },
        accountJoinedAt: { type: "number", input: false },
      },
    }),
    // Mirrors the server's admin() plugin (same ac/roles) so session.user.role
    // is typed and authClient.admin.checkRolePermission can check it locally.
    adminClient({ ac, roles }),
  ],
});
